// extracted by css-extract-rspack-plugin
export default {"root":"root--WmwqqYJ8DhQsPZqE","year":"year--yPFqFMRcz4wyEuZj","hint":"hint--HlU59lfpt0u5XSpU"};